/* @flow */
import createChainedFunction from 'utils/createChainedFunction';
import EmitterMixin from 'components/mixins/EmitterMixin';
import EventTracking, { getEventProperties } from 'lib/EventTracking';
import LayerAutoFocus from 'components/mixins/LayerAutoFocus';
import LayerHideOnEscape from 'components/mixins/LayerHideOnEscape';
import LayerHideOnTransition from 'components/mixins/LayerHideOnTransition';
import React from 'react';
import ScrollContext from 'components/ScrollContext.jsx';

import cx from 'classnames';
import './styles/Modal.scss';

const stack = [];

 /**
  * Class that encapsulates Modal behaviour.
  * Do NOT use this class to create your own Modal, instead,
  * use Dialog.jsx, which leverages Modal.jsx
  */

const Modal = React.createClass({
  propTypes: {
    onRequestHide: React.PropTypes.func,
    theme: React.PropTypes.oneOf(['default', 'dark']),
    hideOnBlur: React.PropTypes.bool,
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  },

  contextTypes: {
    eventProperties: React.PropTypes.object,
  },

  mixins: [
    LayerAutoFocus,
    LayerHideOnEscape,
    LayerHideOnTransition,
    EmitterMixin,
  ],

  statics: {
    getCurrent() {
      return stack[stack.length - 1];
    },
  },

  getDefaultProps() {
    return {
      theme: 'default',
      hideOnBlur: true,
    };
  },

  componentDidMount() {
    stack.push(this);
    this.emit('show');

    const { eventScreenName, eventProperties } = this.props;
    if (eventScreenName) {
      const computedEventProperties = getEventProperties(eventProperties, this.context);
      EventTracking.view(eventScreenName, computedEventProperties);
    }
  },

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);
    }
    this.emit('hide');
  },

  // typecheck: ignore statement
  handleClick(event: SyntheticEvent) {
    if (!this.props.hideOnBlur) {
      return;
    }

    // $FlowFixMe
    if (event.target === event.currentElement) {
      if (this.props.onRequestHide) {
        this.props.onRequestHide();
      }
    }
  },

  render() {
    return (
      <ScrollContext
        {...this.props}
        className={cx({
          Modal: true,
          'Modal-dark': this.props.theme === 'dark',
        }, this.props.className)}
        onClick={createChainedFunction(this.props.onClick, this.handleClick)}
        tabIndex={0}>
        {this.props.children}
      </ScrollContext>
    );
  },
});

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.jsx